import * as React from 'react';
import { View, Text } from 'react-native';
export default class BasicBuddle extends React.PureComponent {
    render() {
        const { text, wrapperStyle, textStyle, angleStyle, topAngle, bottomAngle } = this.props;
        return (<View>
                {topAngle ? (<View style={{ alignItems: 'center', height: 3 }}>
                        <View style={angleStyle}/>
                    </View>) : null}
                <View style={wrapperStyle}>
                    <Text numberOfLines={1} style={textStyle}>
                        {text}
                    </Text>
                </View>
                {bottomAngle ? (<View style={{ alignItems: 'center', height: 3 }}>
                        <View style={angleStyle}/>
                    </View>) : null}
            </View>);
    }
}
